module.exports = __webpack_public_path__ + "img/user-no-img.d57e3e8.jpg";